import { Backdrop, CircularProgress, Paper, Stack, Typography } from '@mui/material';
import { LOADING } from '../../../constants/messages';

export default function SpinnerModal() {
	return (
		<Backdrop sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }} open>
			<Paper elevation={0} sx={{ borderRadius: '1rem' }}>
				<Stack alignItems="center" height="10rem" padding="1.5rem" width="10rem">
					<CircularProgress size="5rem" color="primary" />
					<Typography pt="0.5rem">{LOADING}</Typography>
				</Stack>
			</Paper>
		</Backdrop>
	);
}
